var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "field_head",
      class: { "cursor-pointer": this.can_sort },
      on: { click: _vm.setListOrdering },
    },
    [
      _vm._v("\n    " + _vm._s(this.field_name) + "\n\n    "),
      _vm.is_current_field_sort
        ? _c("div", { staticClass: "badge badge-info" }, [
            _c("i", {
              staticClass: "fal opacity-100 color-white",
              class: _vm.current_sort_class,
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }